export const dashboardContext = require.context(".", true, /\_controller.js$/)
